import { GzGenericDetailsSection } from './component/GzGenericDetailsSection';
import { WEB_COMPONENT_GZ_GENERIC_DETAILS_SECTION } from '../../webcomponents.constants';

export { GzGenericDetailsSection };

window.customElements.define(WEB_COMPONENT_GZ_GENERIC_DETAILS_SECTION, GzGenericDetailsSection);
